const tipoff = {
  namespaced: true,
  state: {
    metadata: {
      'mod': 'nis-tipoff'
    }
  },
  getters: {},
  mutations: {
  },
  actions: {}
}

export default tipoff
